import { combineReducers } from 'redux'
import randomQuotesReducer from './randomquotes/randomQuotesSlice'
import lycopersicumReducer from './lycopersicum/lycopersicumSlice'

export default combineReducers({
  randomquotes: randomQuotesReducer,
  lycopersicum: lycopersicumReducer
})